$(".form-newsletter .form-trigger").on("click", async function(e) {
  e.preventDefault();

  const target = e.currentTarget;
  const parent = target.closest(".form-newsletter");

  const errors = validate(parent);

  if (errors.length <= 0) {
    $(parent)
      .find(".button-with-loader")
      .addClass("button--loading");

    const email = $(parent)
      .find("input[name=email]")
      .val();

    try {
      const response = await fetch(
        "https://api.sirio.chiron.ai/api/v1/newsletter",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer CXgvelv5zSIp3NZ5RLDkiHtB81AG2elRCvSUfBIRvwBxYkejr0Npn4cb4Y0tqdvrmksA5nsBz2eHB1k4",
          },
          body: JSON.stringify({
            lang: window.ortica.lang,
            vals: {
              email: email,
              list_ids: [12],
            },
          }),
        }
      );

      const json = await response.json();

      $(parent)
        .find(".button-with-loader")
        .removeClass("button--loading");

      $(parent)
        .find("input[name=email]")
        .val("");

      $(parent)
        .find("input[name=privacy]")
        .prop("checked", false);

      $(parent)
        .find(".response")
        .css("transiton", "opacity .7s")
        .removeClass("opacity-0");

      setTimeout(() => {
        $(parent)
          .parents(".pum")
          .find(".pum-close.popmake-close")
          .trigger("click");
      }, 1000);
    } catch (e) {
      console.log(e);
    }
  }
});

$(".form-newsletter input").on("input change", (e) => {
  singleValidation({ target: e.currentTarget });
});

function handleErrorMessage(valid, input, messages) {
  const parentContainer = input.closest(".relative");

  $(parentContainer)
    .find(".error-message")
    .remove();

  if (valid) return;

  const markup = `<span class="error-message">${messages.join("</br>")}</span>`;

  $(parentContainer).append(markup);
}

function validate(parent) {
  let errors = [];

  const inputs = parent.querySelectorAll("input");
  const selects = parent.querySelectorAll("select");

  Array.from(inputs).forEach((input) => {
    const [valid, messages] = singleValidation({ target: input });

    errors = errors.concat(messages);
  });

  Array.from(selects).forEach((select) => {
    const [valid, messages] = singleValidation({ target: select });

    errors = errors.concat(messages);
  });

  return errors;
}

function singleValidation(e) {
  const input = e.target;
  const rules = $(input).data("validationrules");
  let value;

  // empty don't need to do anyting
  if (Array.isArray(rules) || !rules) return [true, []];

  if (input.nodeName.toLowerCase() === "select") {
    value = input.selectedOptions[0].disabled ? null : input.value;
  } else {
    value = input.type == "checkbox" ? input.checked : input.value;
  }

  const [valid, messages] = isValid(value, rules);

  handleErrorMessage(valid, input, messages);

  return [valid, messages];
}

function isValid(value, rules) {
  let valid = true;

  const messages = [];

  if (rules.required) {
    valid = valid && value;

    if (typeof value === "boolean") valid = value;
    else valid = valid && value.length > 0;

    if (!valid) {
      messages.push(rules.required[1]);
    }
  }

  if (rules.test && value) {
    const regexp = new RegExp(rules.test[0]);

    valid = valid && regexp.test(value);

    if (!valid) {
      messages.push(rules.test[1]);
    }
  }

  return [valid, messages];
}
